import React, { useEffect, useState, useRef } from 'react';
import { Canvas, useFrame } from '@react-three/fiber';
import { OrbitControls, PerspectiveCamera, Text } from '@react-three/drei';
import * as THREE from 'three';
import SponsortsBar from '../../structural/screen/sponsorsBar';

const tileTypes = [
  // GRAIMÁN 20x20 cm
  {
    id: 1,
    brand: "GRAIMÁN",
    name: "BLANCO NIEVE 20X20 CM",
    size: 0.20,
    thickness: 0.008,
    weight: 1,
    price: 3.50,
    color: "#ffffff",
    img: ""
  },
  {
    id: 2,
    brand: "GRAIMÁN",
    name: "GRIS PLATA 20X20 CM",
    size: 0.20,
    thickness: 0.008,
    weight: 1,
    price: 3.75,
    color: "#c0c0c0",
    img: ""
  },
  {
    id: 3,
    brand: "GRAIMÁN",
    name: "BEIGE ARENA 20X20 CM",
    size: 0.20,
    thickness: 0.008,
    weight: 1,
    price: 4.00,
    color: "#f5d7a1",
    img: ""
  },
  {
    id: 4,
    brand: "GRAIMÁN",
    name: "TERRAZO CLÁSICO 20X20 CM",
    size: 0.20,
    thickness: 0.008,
    weight: 1.1,
    price: 4.25,
    color: "#d9c7b8",
    img: ""
  },

  // GRAIMÁN 30x30 cm
  {
    id: 5,
    brand: "GRAIMÁN",
    name: "BLANCO MARFIL 30X30 CM",
    size: 0.30,
    thickness: 0.008,
    weight: 1.2,
    price: 5.50,
    color: "#f8f4e6",
    img: ""
  },
  {
    id: 6,
    brand: "GRAIMÁN",
    name: "GRIS PERLA 30X30 CM",
    size: 0.30,
    thickness: 0.008,
    weight: 1.2,
    price: 5.75,
    color: "#e5e4e2",
    img: ""
  },
  {
    id: 7,
    brand: "GRAIMÁN",
    name: "MADERA CLARA 30X30 CM",
    size: 0.30,
    thickness: 0.008,
    weight: 1.3,
    price: 6.00,
    color: "#d2b48c",
    img: ""
  },
  {
    id: 8,
    brand: "GRAIMÁN",
    name: "PIEDRA NATURAL 30X30 CM",
    size: 0.30,
    thickness: 0.008,
    weight: 1.4,
    price: 6.25,
    color: "#a8a59b",
    img: ""
  },

  // GRAIMÁN 40x40 cm
  {
    id: 9,
    brand: "GRAIMÁN",
    name: "BLANCO PURO 40X40 CM",
    size: 0.40,
    thickness: 0.008,
    weight: 1.8,
    price: 7.50,
    color: "#f9f9f9",
    img: ""
  },
  {
    id: 10,
    brand: "GRAIMÁN",
    name: "GRIS INDUSTRIAL 40X40 CM",
    size: 0.40,
    thickness: 0.008,
    weight: 1.8,
    price: 7.75,
    color: "#7d7d7d",
    img: ""
  },
  {
    id: 11,
    brand: "GRAIMÁN",
    name: "TERRAZO MODERNO 40X40 CM",
    size: 0.40,
    thickness: 0.008,
    weight: 1.9,
    price: 8.00,
    color: "#c5beb6",
    img: ""
  },
  {
    id: 12,
    brand: "GRAIMÁN",
    name: "MADERA NOGAL 40X40 CM",
    size: 0.40,
    thickness: 0.008,
    weight: 1.9,
    price: 8.25,
    color: "#3a2c1a",
    img: ""
  },

  // PORCELANOSA 30x60 cm
  {
    id: 13,
    brand: "PORCELANOSA",
    name: "MÁRMOL CARRARA 30X60 CM",
    size: 0.30,
    length: 0.60,
    thickness: 0.008,
    weight: 1.5,
    price: 15.00,
    color: "#f5f5f5",
    img: "",
    rectangular: true
  },
  {
    id: 14,
    brand: "PORCELANOSA",
    name: "MÁRMOL NEGRO 30X60 CM",
    size: 0.30,
    length: 0.60,
    thickness: 0.008,
    weight: 1.6,
    price: 16.00,
    color: "#212121",
    img: "",
    rectangular: true
  },
  {
    id: 15,
    brand: "PORCELANOSA",
    name: "CEMENTO PULIDO 30X60 CM",
    size: 0.30,
    length: 0.60,
    thickness: 0.008,
    weight: 1.5,
    price: 14.50,
    color: "#9e9e9e",
    img: "",
    rectangular: true
  },
  {
    id: 16,
    brand: "PORCELANOSA",
    name: "METALIZADO BRONCE 30X60 CM",
    size: 0.30,
    length: 0.60,
    thickness: 0.008,
    weight: 1.7,
    price: 17.00,
    color: "#cd7f32",
    img: "",
    rectangular: true
  },

  // PORCELANOSA 60x60 cm
  {
    id: 17,
    brand: "PORCELANOSA",
    name: "MÁRMOL TRAVERTINO 60X60 CM",
    size: 0.60,
    thickness: 0.010,
    weight: 3.5,
    price: 22.00,
    color: "#e6d6b9",
    img: ""
  },
  {
    id: 18,
    brand: "PORCELANOSA",
    name: "PIEDRA VOLCÁNICA 60X60 CM",
    size: 0.60,
    thickness: 0.010,
    weight: 3.6,
    price: 23.00,
    color: "#4a4a4a",
    img: ""
  },
  {
    id: 19,
    brand: "PORCELANOSA",
    name: "TERRAZO VINTAGE 60X60 CM",
    size: 0.60,
    thickness: 0.010,
    weight: 3.4,
    price: 21.50,
    color: "#c4b8a8",
    img: ""
  },
  {
    id: 20,
    brand: "PORCELANOSA",
    name: "CONCRETO URBANO 60X60 CM",
    size: 0.60,
    thickness: 0.010,
    weight: 3.7,
    price: 22.50,
    color: "#7a7a7a",
    img: ""
  },

  // CERACASA 25x50 cm
  {
    id: 21,
    brand: "CERACASA",
    name: "RÚSTICO TERRA 25X50 CM",
    size: 0.25,
    length: 0.50,
    thickness: 0.009,
    weight: 1.7,
    price: 10.50,
    color: "#a67c52",
    img: "",
    rectangular: true
  },
  {
    id: 22,
    brand: "CERACASA",
    name: "RÚSTICO PIEDRA 25X50 CM",
    size: 0.25,
    length: 0.50,
    thickness: 0.009,
    weight: 1.8,
    price: 11.00,
    color: "#8b8680",
    img: "",
    rectangular: true
  },
  {
    id: 23,
    brand: "CERACASA",
    name: "RÚSTICO MADERA 25X50 CM",
    size: 0.25,
    length: 0.50,
    thickness: 0.009,
    weight: 1.7,
    price: 10.75,
    color: "#8b5a2b",
    img: "",
    rectangular: true
  },
  {
    id: 24,
    brand: "CERACASA",
    name: "RÚSTICO CALIZA 25X50 CM",
    size: 0.25,
    length: 0.50,
    thickness: 0.009,
    weight: 1.8,
    price: 11.25,
    color: "#d8d0c7",
    img: "",
    rectangular: true
  },

  // VENIS 60x120 cm
  {
    id: 25,
    brand: "VENIS",
    name: "METALIZADO PLATA 60X120 CM",
    size: 0.60,
    length: 1.20,
    thickness: 0.011,
    weight: 4.5,
    price: 28.00,
    color: "#e0e0e0",
    img: "",
    rectangular: true
  },
  {
    id: 26,
    brand: "VENIS",
    name: "METALIZADO ORO 60X120 CM",
    size: 0.60,
    length: 1.20,
    thickness: 0.011,
    weight: 4.6,
    price: 30.00,
    color: "#ffd700",
    img: "",
    rectangular: true
  },
  {
    id: 27,
    brand: "VENIS",
    name: "METALIZADO COBRE 60X120 CM",
    size: 0.60,
    length: 1.20,
    thickness: 0.011,
    weight: 4.7,
    price: 29.00,
    color: "#b87333",
    img: "",
    rectangular: true
  },
  {
    id: 28,
    brand: "VENIS",
    name: "METALIZADO GRAFITO 60X120 CM",
    size: 0.60,
    length: 1.20,
    thickness: 0.011,
    weight: 4.8,
    price: 31.00,
    color: "#383838",
    img: "",
    rectangular: true
  },

  // URBATEK 75x75 cm
  {
    id: 29,
    brand: "URBATEK",
    name: "CONCRETO INDUSTRIAL 75X75 CM",
    size: 0.75,
    thickness: 0.012,
    weight: 5.0,
    price: 35.00,
    color: "#616161",
    img: ""
  },
  {
    id: 30,
    brand: "URBATEK",
    name: "HORMIGÓN PULIDO 75X75 CM",
    size: 0.75,
    thickness: 0.012,
    weight: 5.1,
    price: 36.00,
    color: "#9e9e9e",
    img: ""
  },
  {
    id: 31,
    brand: "URBATEK",
    name: "MICROCEMENTO 75X75 CM",
    size: 0.75,
    thickness: 0.012,
    weight: 5.0,
    price: 37.00,
    color: "#d6d6d6",
    img: ""
  },
  {
    id: 32,
    brand: "URBATEK",
    name: "TERRAZO INDUSTRIAL 75X75 CM",
    size: 0.75,
    thickness: 0.012,
    weight: 5.2,
    price: 38.00,
    color: "#c5beb6",
    img: ""
  }
];

const mortarDensity = 1.6;
const mortarPrice = 120;
const adhesivePrice = 80;
const boundexThickness = 0.01;
const tileThickness = 0.005;

const roundTo4 = (num) => Math.round(num * 10000) / 10000;

const TileFloor = () =>
{  
  const calculatorType = 'ceramic_floor';

  const [openMenu, setOpenMenu] = useState(null);
  const [isMobile, setIsMobile] = useState(window.innerWidth < 768);
  const menuRef = useRef();

  const [floorDimensions, setFloorDimensions] = useState({
    length: 3.45,
    width: 2.30
  });

  const [mortarGap, setMortarGap] = useState(3);
  const [selectedBrand, setSelectedBrand] = useState(null);
  const [selectedSize, setSelectedSize] = useState(null);
  const [selectedTile, setSelectedTile] = useState(tileTypes[0]);
  const [filteredTiles, setFilteredTiles] = useState([]);
  const [availableSizes, setAvailableSizes] = useState([]);
  
  const [results, setResults] = useState({
    fullTiles: 0,
    cutTiles: [],
    boundex: 0,
    groutex: 0,
    adhesive: 0,
    totalWeight: 0,
    weightPerSquareMeter: 0,
    floorArea: 0,
    tilesCost: 0,
    boundexCost: 0,
    groutexCost: 0,
    adhesiveCost: 0,
    totalCost: 0
  });

  // Obtener todas las marcas disponibles
  const brands = [...new Set(tileTypes.map(tile => tile.brand))];

  useEffect(() =>
  {
    if (selectedBrand)
    {
      // Filtrar tamaños disponibles para la marca seleccionada
      const brandTiles = tileTypes.filter(tile => tile.brand === selectedBrand);
      const sizes = [...new Set(brandTiles.map(tile => 
        tile.rectangular ? `${tile.size*100}x${tile.length*100} cm` : `${tile.size*100}x${tile.size*100} cm`
      ))];
      setAvailableSizes(sizes);
      setSelectedSize(null);
      setSelectedTile(null);
    }
  }, [selectedBrand]);

  useEffect(() =>
  {
    if (selectedBrand && selectedSize)
    {
      // Filtrar cerámicas que coincidan con marca y tamaño
      const [width, height] = selectedSize.split('x').map(val => parseFloat(val)/100);
      const filtered = tileTypes.filter(tile => 
        tile.brand === selectedBrand && 
        ((tile.rectangular && tile.size === width && tile.length === height) ||
        (!tile.rectangular && tile.size === width && tile.size === height))
      );
      
      setFilteredTiles(filtered);
      
      if (filtered.length > 0)
      {
        setSelectedTile(filtered[0]);
      }
    }
  }, [selectedBrand, selectedSize]);

  useEffect(() =>
  {
    calculateMaterials();
  }, [floorDimensions, selectedTile, mortarGap]);

  const calculateMaterials = () =>
  {
    if (!selectedTile) return;
    
    const { length, width } = floorDimensions;
    const { size, thickness, weight, price, rectangular, length: tileLength } = selectedTile;
    const mortarGapMeters = mortarGap / 1000;

    let fullTiles = 0;
    const cutTiles = [];
    
    const floorArea = length * width;

    let currentY = 0;
    let tilesInRow = 0;
    let tilesInColumn = 0;

    // Para cerámicas rectangulares
    const tileSizeX = rectangular ? size : size;
    const tileSizeY = rectangular ? tileLength : size;

    while (currentY < width) {
      const remainingY = width - currentY;
      const currentTileSizeY = Math.min(tileSizeY, remainingY);
      
      let currentX = 0;
      tilesInRow = 0;
      
      while (currentX < length) {
        const remainingX = length - currentX;
        const currentTileSizeX = Math.min(tileSizeX, remainingX);

        if (Math.abs(currentTileSizeX - tileSizeX) < 0.001 && Math.abs(currentTileSizeY - tileSizeY) < 0.001) {
          fullTiles++;
        } else {
          cutTiles.push({
            width: currentTileSizeX,
            height: currentTileSizeY,
            thickness: thickness
          });
        }
        
        tilesInRow++;
        currentX += currentTileSizeX;
        
        if (currentX < length) {
          currentX += mortarGapMeters;
        }
      }
      
      currentY += currentTileSizeY;
      tilesInColumn++;
      
      if (currentY < width) {
        currentY += mortarGapMeters;
      }
    }

    const boundex = floorArea * boundexThickness;
    const verticalJoints = (tilesInRow - 1) * width * mortarGapMeters * thickness;
    const horizontalJoints = (tilesInColumn - 1) * length * mortarGapMeters * thickness;
    const groutex = verticalJoints + horizontalJoints;
    const adhesive = floorArea * 0.003;

    const tileArea = rectangular ? (size * tileLength) : (size * size);
    const cutTilesWeight = cutTiles.reduce((sum, tile) => {
      return sum + (tile.width * tile.height * weight / tileArea);
    }, 0);

    const totalWeight = (fullTiles * weight) + cutTilesWeight + 
                       (boundex * mortarDensity * 1000) +
                       (groutex * mortarDensity * 1000) + 
                       (adhesive * mortarDensity * 1000);

    const weightPerSquareMeter = totalWeight / floorArea;

    const tilesCost = fullTiles * selectedTile.price + 
                     cutTiles.length * selectedTile.price * 0.7;
    const boundexCost = boundex * mortarPrice;
    const groutexCost = groutex * mortarPrice;
    const adhesiveCost = adhesive * adhesivePrice;
    const totalCost = tilesCost + boundexCost + groutexCost + adhesiveCost;

    setResults({
      fullTiles,
      cutTiles,
      boundex,
      groutex,
      adhesive,
      totalWeight,
      weightPerSquareMeter,
      floorArea,
      tilesCost,
      boundexCost,
      groutexCost,
      adhesiveCost,
      totalCost
    });
  };

  const handleDimensionChange = (e) => {
    const { name, value } = e.target;
    const numericValue = parseFloat(value) || 0;
    const roundedValue = Math.max(0.05, Math.round(numericValue * 20) / 20);
    setFloorDimensions(prev => ({
      ...prev,
      [name]: roundedValue
    }));
  };

  const handleMortarGapChange = (e) => {
    const value = parseFloat(e.target.value) || 0;
    const roundedValue = Math.round(value);
    const clampedValue = Math.max(1, Math.min(5, roundedValue));
    setMortarGap(clampedValue);
  };

  const formatDimension = (value) => {
    const cmValue = Math.round(value * 100);
    return cmValue % 1 === 0 ? cmValue : cmValue.toFixed(1);
  };

  const formatCurrency = (value) => {
    return new Intl.NumberFormat('es-ES', { style: 'currency', currency: 'USD' }).format(value);
  };

  const renderCutTiles = () => {
    const counts = {};
    results.cutTiles.forEach(tile => {
      const key = `${formatDimension(tile.width)}x${formatDimension(tile.height)} cm`;
      counts[key] = (counts[key] || 0) + 1;
    });

    return Object.entries(counts).map(([size, count]) => (
      <p key={size} className="text-sm">
        <span className="font-semibold">{size}:</span> {count}
      </p>
    ));
  };

  const toggleMenu = (menuName) => {
    setOpenMenu(openMenu === menuName ? null : menuName);
  };

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (menuRef.current && !menuRef.current.contains(event.target)) {
        setOpenMenu(null);
      }
    };

    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, []);

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth < 768);
    };

    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  if (isMobile) {
    return <MobileWarning />;
  }

  return (
    <div className="flex flex-col h-screen">
      <div ref={menuRef} className="bg-gray-800 text-white flex justify-between items-center px-4 py-2 z-[3000]">
        <div className="flex space-x-4">        
          <div className="relative">
            <button 
              className="hover:bg-gray-600 px-3 py-1 rounded bg-gray-700"
              onClick={() => toggleMenu('creditos')}
            >
              Créditos
            </button>
            <div className={`absolute left-0 mt-1 ${openMenu === 'creditos' ? 'block' : 'hidden'} bg-white text-black rounded shadow w-[300px]`}>
              <a 
                href="https://www.linkedin.com/in/entornoceo/" 
                target="_blank" 
                rel="noopener noreferrer"
                className="block font-bold text-black px-4 py-2 hover:bg-gray-100 w-full text-left cursor-pointer"
              >
                Creado por: Ing. Javier Hernández
              </a>             
            </div>
          </div>
        </div>
        <div>
          <span className="font-bold uppercase">Calculadora de Cerámica</span>
        </div>
      </div>

      <div className={`flex ${isMobile ? 'flex-col-reverse' : 'overflow-hidden'} h-full`}>
        <div className={`${isMobile ? 'flex-1' : 'flex flex-col flex-1'} bg-gray-50 p-1`}>
          <div className="h-full w-full">
            <Canvas>
              <ambientLight intensity={0.5} />
              <spotLight position={[10, 10, 10]} angle={0.15} penumbra={1} />
              <PerspectiveCamera makeDefault position={[0, 5, 5]} rotation={[-Math.PI / 4, 0, 0]} />
              <OrbitControls enablePan={true} enableZoom={true} enableRotate={true} />
              {selectedTile && (
                <Floor3D floor={floorDimensions} tile={selectedTile} mortarGap={mortarGap / 1000} />
              )}
            </Canvas>
          </div>

          <div className="flex flex-col bg-gray-50 p-1 flex-1">
            <SponsortsBar
              calculatorType={calculatorType}
            />
          </div>
        </div>        

        <div className="bg-white border-l p-4 bg-gray-200 overflow-y-auto z-50 min-w-3/12 w-[400px]">          
          <h2 className="text-xl font-semibold mb-4">Parámetros del Piso</h2>
              
          <div className="space-y-4">
            {['length', 'width'].map((dim) => (
              <div key={dim}>
                <label className="block text-sm font-medium text-gray-700">
                  {dim === 'length' ? 'Longitud' : 'Ancho'} (m)
                </label>
                <input
                  type="number"
                  name={dim}
                  value={floorDimensions[dim]}
                  onChange={handleDimensionChange}
                  className="mt-1 block w-full rounded-md border-gray-300 shadow-sm p-2 border"
                  min="1"
                  step="0.05"
                />
                <p className="text-xs text-gray-500">Incrementos de 5 cm (mínimo 1 metro)</p>
              </div>
            ))}

            <div>
              <label className="block text-sm font-medium text-gray-700">Espesor de juntas (mm)</label>
              <input
                type="number"
                value={mortarGap}
                onChange={handleMortarGapChange}
                className="mt-1 block w-full rounded-md border-gray-300 shadow-sm p-2 border"
                min="1"
                max="5"
                step="1"
              />
              <p className="text-xs text-gray-500">Incrementos de 1 mm (mínimo 1 mm, máximo 5 mm)</p>
            </div>

            <div>
              <label className="block text-sm font-medium text-gray-700">Marca</label>
              <select
                value={selectedBrand || ''}
                onChange={(e) => setSelectedBrand(e.target.value || null)}
                className="mt-1 block w-full rounded-md border-gray-300 shadow-sm p-2 border"
              >
                <option value="">Seleccione una marca</option>
                {brands.map(brand => (
                  <option key={brand} value={brand}>{brand}</option>
                ))}
              </select>
            </div>

            {selectedBrand && (
              <div>
                <label className="block text-sm font-medium text-gray-700">Tamaño</label>
                <select
                  value={selectedSize || ''}
                  onChange={(e) => setSelectedSize(e.target.value || null)}
                  className="mt-1 block w-full rounded-md border-gray-300 shadow-sm p-2 border"
                  disabled={!selectedBrand}
                >
                  <option value="">Seleccione un tamaño</option>
                  {availableSizes.map(size => (
                    <option key={size} value={size}>{size}</option>
                  ))}
                </select>
              </div>
            )}

            {selectedSize && (
              <div>
                <label className="block text-sm font-medium text-gray-700">Modelo</label>
                <select
                  value={selectedTile?.id || ''}
                  onChange={(e) => setSelectedTile(filteredTiles.find(t => t.id === parseInt(e.target.value)))}
                  className="mt-1 block w-full rounded-md border-gray-300 shadow-sm p-2 border"
                  disabled={!selectedSize}
                >
                  <option value="">Seleccione un modelo</option>
                  {filteredTiles.map(tile => (
                    <option key={tile.id} value={tile.id}>{tile.name} - {formatCurrency(tile.price)}/ud</option>
                  ))}
                </select>
              </div>
            )}
          </div>

          {selectedTile && (
            <>
              <h3 className="text-lg font-medium my-3">Resultados</h3>

              <div className="space-y-2 mb-4">
                <p><span className="font-semibold">Área del piso:</span> {results.floorArea.toFixed(2)} m²</p>
                
                <h4 className="font-semibold mt-2 uppercase underline">Materiales:</h4>
                <p><span className="font-semibold">Cerámicas completas:</span> {results.fullTiles}</p>
                
                <h4 className="font-semibold mt-2">Cerámicas cortadas:</h4>
                {results.cutTiles.length > 0 ? renderCutTiles() : <p className="text-sm">No hay cerámicas cortadas</p>}
                
                <h4 className="font-semibold mt-2 uppercase underline">Morteros:</h4>
                <p className="text-sm"><span className="font-semibold">Boundex (1cm):</span> {results.boundex.toFixed(4)} m³</p>
                <p className="text-sm"><span className="font-semibold">Groutex (juntas):</span> {results.groutex.toFixed(4)} m³</p>
                
                <h4 className="font-semibold mt-2 uppercase underline">Adhesivo:</h4>
                <p className="text-sm"><span className="font-semibold">Volumen total (3mm):</span> {results.adhesive.toFixed(4)} m³</p>
                
                <h4 className="font-semibold mt-2 uppercase underline">Pesos:</h4>
                <p className="text-sm"><span className="font-semibold">Peso total:</span> {results.totalWeight.toFixed(0)} kg</p>
                <p className="text-sm"><span className="font-semibold">Peso por metro cuadrado:</span> {results.weightPerSquareMeter.toFixed(0)} kg/m²</p>
                
                <h4 className="font-semibold mt-2 uppercase underline">Costos:</h4>
                <p className="text-sm"><span className="font-semibold">Costo cerámicas:</span> {formatCurrency(results.tilesCost)}</p>
                <p className="text-sm"><span className="font-semibold">Costo boundex:</span> {formatCurrency(results.boundexCost)}</p>
                <p className="text-sm"><span className="font-semibold">Costo groutex:</span> {formatCurrency(results.groutexCost)}</p>
                <p className="text-sm"><span className="font-semibold">Costo adhesivo:</span> {formatCurrency(results.adhesiveCost)}</p>
                <p className="text-sm"><span className="font-semibold">Costo total:</span> {formatCurrency(results.totalCost)}</p>
              </div>
            </>
          )}
        </div>
      </div>
    </div>
  );
};

const Floor3D = ({ floor, tile, mortarGap }) => {
  const { length, width } = floor;
  const { size, thickness, color, rectangular, length: tileLength } = tile;

  const lengthTextRef = useRef();
  const widthTextRef = useRef();

  useFrame(({ camera }) => {
    if (lengthTextRef.current) lengthTextRef.current.lookAt(camera.position);
    if (widthTextRef.current) widthTextRef.current.lookAt(camera.position);
  });

  const tiles = [];
  let currentY = -width/2;

  // Tamaños reales de la cerámica
  const tileSizeX = rectangular ? size : size;
  const tileSizeY = rectangular ? tileLength : size;

  // Base del piso (concreto)
  tiles.push(
    <mesh
      key="base-floor"
      position={[0, -thickness - 0.05, 0]}
      rotation={[-Math.PI / 2, 0, 0]}
    >
      <planeGeometry args={[length + 0.1, width + 0.1]} />
      <meshStandardMaterial color="#888888" />
    </mesh>
  );

  // Boundex (1cm)
  tiles.push(
    <mesh
      key="boundex-layer"
      position={[0, -thickness/2, 0]}
      rotation={[-Math.PI / 2, 0, 0]}
    >
      <planeGeometry args={[length, width]} />
      <meshStandardMaterial color="#aaaaaa" />
    </mesh>
  );

  // Adhesivo (3mm)
  tiles.push(
    <mesh
      key="adhesive-layer"
      position={[0, -0.002, 0]}
      rotation={[-Math.PI / 2, 0, 0]}
    >
      <planeGeometry args={[length, width]} />
      <meshStandardMaterial color="#cccccc" transparent opacity={0.7} />
    </mesh>
  );

  // Cerámicas
  while (currentY < width/2) {
    const remainingY = width/2 - currentY;
    const currentTileSizeY = Math.min(tileSizeY, remainingY);
    
    let currentX = -length/2;    
    
    while (currentX < length/2) {
      const remainingX = length/2 - currentX;
      const currentTileSizeX = Math.min(tileSizeX, remainingX);

      const randomYAngle = roundTo4(Math.random(-0.05,0.05) * Math.PI / 180)/5;
      const randomZAngle = roundTo4(Math.random(-0.05,0.05) * Math.PI / 180)/3;

      if (currentTileSizeX > 0.01) {
        tiles.push(
          <group key={`${currentY}-${currentX}`}>
            <mesh
              position={[currentX + currentTileSizeX/2, 0, currentY + currentTileSizeY/2]}
              rotation={[0, randomYAngle, randomZAngle]}
            >
              <boxGeometry args={[currentTileSizeX, tileThickness, currentTileSizeY]} />
              <meshStandardMaterial color={color} />
            </mesh>
            <lineSegments 
              position={[currentX + currentTileSizeX/2, 0.001, currentY + currentTileSizeY/2]}
              rotation={[0, randomYAngle, randomZAngle]}
            >
              <edgesGeometry args={[new THREE.BoxGeometry(currentTileSizeX, tileThickness, currentTileSizeY)]} />
              <lineBasicMaterial color="#111111" linewidth={1} />
            </lineSegments>
          </group>
        );
        
        currentX += currentTileSizeX;
        
        if (currentX < length/2) {
          tiles.push(
            <mesh
              key={`groutex-v-${currentY}-${currentX}`}
              position={[currentX + mortarGap/2, 0.002, currentY + currentTileSizeY/2]}
              rotation={[-Math.PI / 2, 0, 0]}
            >
              <planeGeometry args={[mortarGap, currentTileSizeY]} />
              <meshStandardMaterial color="#dddddd" />
            </mesh>
          );
          currentX += mortarGap;
        }
      } else {
        break;
      }
    }
    
    currentY += currentTileSizeY;
    
    if (currentY < width/2) {
      tiles.push(
        <mesh
          key={`groutex-h-${currentY}`}
          position={[0, 0.002, currentY + mortarGap/2]}
          rotation={[-Math.PI / 2, 0, 0]}
        >
          <planeGeometry args={[length, mortarGap]} />
          <meshStandardMaterial color="#dddddd" />
        </mesh>
      );
      currentY += mortarGap;
    }
  }

  return (
    <group>
      {/* Medida de longitud (eje X) - abajo */}
      <group ref={lengthTextRef} position={[0, 0.1, -width/2 - 0.1]}>
        <Text color="black" anchorX="center" anchorY="middle" fontSize={0.1}>
          {length.toFixed(2)} m
        </Text>
      </group>

      <group ref={lengthTextRef} position={[-length/2 - 0.1, 0.1, 0.1]}>
        <Text color="black" anchorX="center" anchorY="middle" fontSize={0.1}>
          {width.toFixed(2)} m
        </Text>
      </group>
      
      {/* Medida de ancho (eje Z) - lado derecho */}
      <group ref={widthTextRef} position={[length/2 + 0.1, 0.1, 0]}>
        <Text 
          color="black" 
          anchorX="center" 
          anchorY="middle" 
          fontSize={0.1}
          rotation={[0, Math.PI/2, 0]}
        >
          {width.toFixed(2)} m
        </Text>
      </group>
      
      {tiles}
    </group>
  );
};

const MobileWarning = () => {
  return (
    <div style={{
      position: 'fixed',
      top: 0,
      left: 0,
      width: '100%',
      height: '100%',
      backgroundColor: 'white',
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      textAlign: 'center',
      zIndex: 9999,
      padding: '20px',
      boxSizing: 'border-box',
      fontFamily: 'Arial, sans-serif',
    }}>
      <div>
        <h2>Esta calculadora por el momento solo funciona en PC</h2>
        <p>Por favor, accede desde un ordenador para utilizarla.</p>
      </div>
    </div>
  );
};

export default TileFloor;